import catalog from "./map-creator-generated-props.json";

export const MAP_CREATOR_GENERATED_PROP_CATEGORIES = ["furniture", "architecture", "dungeon", "nature", "settlement", "arcane", "sacred", "battlefield", "nautical", "biomes"] as const;

export type MapCreatorGeneratedPropCategory = typeof MAP_CREATOR_GENERATED_PROP_CATEGORIES[number];
export type MapCreatorGeneratedDecorationKind = keyof typeof catalog;

export interface MapCreatorGeneratedPropDefinition {
  label: string;
  category: MapCreatorGeneratedPropCategory;
  subject: string;
  scale: number;
  shadowHeight: number;
  flat?: boolean;
  natural?: boolean;
}

export const MAP_CREATOR_GENERATED_PROPS = catalog as Record<MapCreatorGeneratedDecorationKind, MapCreatorGeneratedPropDefinition>;
export const MAP_CREATOR_GENERATED_PROP_KINDS = Object.freeze(Object.keys(MAP_CREATOR_GENERATED_PROPS) as MapCreatorGeneratedDecorationKind[]);

export function mapCreatorGeneratedProp(kind: string): MapCreatorGeneratedPropDefinition | undefined {
  return (MAP_CREATOR_GENERATED_PROPS as Record<string, MapCreatorGeneratedPropDefinition | undefined>)[kind];
}

export function mapCreatorGeneratedPropsInCategory(category: MapCreatorGeneratedPropCategory): MapCreatorGeneratedDecorationKind[] {
  return MAP_CREATOR_GENERATED_PROP_KINDS.filter((kind) => MAP_CREATOR_GENERATED_PROPS[kind].category === category);
}
